// Lib
import React from 'react';

// Components
import AiAssistantPopupResultHistory from './AiAssistantPopupResultHistory';

// Types
import { AiHistoryEntry } from '../../state/aiToolStateTypes';

// Styles
import './AiAssistantPopupResultBotHistory.scss';

const AiAssistantPopupResultBotHistory = ({ result }: { result: AiHistoryEntry }): React.ReactElement => {
    return (
        <AiAssistantPopupResultHistory className="AiAssistantPopupResultBotHistory">
            {result.text}
        </AiAssistantPopupResultHistory>
    );
};

export default AiAssistantPopupResultBotHistory;
